"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _constants = require("../../constants");
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _context;
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var styles = {
  "active": "collapsible_panel-module__active___b5i62",
  "header": "collapsible_panel-module__header___KE3oE",
  "collapsed": "collapsible_panel-module__collapsed___AFLHR",
  "container": "collapsible_panel-module__container___KgECX",
  "content": "collapsible_panel-module__content___hGjHl"
};
class CollapsiblePanel extends _react.default.PureComponent {
  static propTypes = {
    enabled: T.bool,
    className: T.string,
    collapsedClassName: T.string,
    displayId: T.string,
    displayString: T.string,
    forwardedRef: T.func,
    actionButtonsElement: T.element,
    expanded: T.bool
  };
  static defaultProps = {
    enabled: true,
    forwardedRef: _constants.NOOP,
    expanded: true
  };
  state = {
    open: this.props.expanded,
    toggled: false
  };
  toggleView = (0, _bind.default)(_context = this.toggleView).call(_context, this);
  toggleView() {
    this.setState(prevState => ({
      open: !prevState.open
    }));
  }
  componentDidUpdate(prevProps) {
    const {
      expanded
    } = this.props;
    if (prevProps.expanded !== expanded) {
      this.setState({
        open: expanded
      });
    }
  }
  render() {
    const {
      enabled,
      className,
      collapsedClassName,
      displayId,
      displayString,
      forwardedRef,
      actionButtonsElement
    } = this.props;
    const {
      open
    } = this.state;
    const classes = (0, _classnames.default)(styles.container, {
      [styles.active]: enabled && open,
      [styles.collapsed]: !open,
      [collapsedClassName]: !open
    }, className);
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes,
      ref: forwardedRef
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.header
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: displayId,
      displayString: displayString,
      onClick: enabled ? this.toggleView : _constants.NOOP,
      tag: "div",
      className: styles.header_title
    }), Boolean(actionButtonsElement) && actionButtonsElement), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.content
    }, open && this.props.children));
  }
}
var _default = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(CollapsiblePanel, (0, _extends2.default)({}, props, {
  forwardedRef: ref
})));
exports.default = _default;